var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.contaierClasses},[_c('label',{class:_vm.labelClasses,attrs:{"for":_vm.id}},[_c('input',_vm._b({attrs:{"type":"checkbox","id":_vm.id,"true-value":1,"false-value":0},domProps:{"checked":_vm.value === _vm.trueValue},on:{"change":_vm.onInput}},'input',_vm.$attrs,false)),_vm._v(" "+_vm._s(_vm.label)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }